<template>
  <div class="goal-view">
    <div class="flex flex-col flex-grow items-start">
      <div class="w-full block flex items-center flex-row pl-4 p-2 bg-gray-300 rounded-t">
        <label for="area" class="flex-1 font-bold text-lg">Goal Area:</label>
        <input
          type="text"
          class="font-bold flex-shrink text-right text-lg rounded py-1 pr-3 focus:border-2 focus:border-gray-800"
          id="area"
          :value="goal.area"
          @change="updateGoalProperty($event, 'area')"
          @keyup.enter="updateGoalProperty($event, 'area')"
        />
      </div>
      <div class="w-full block flex items-center flex-row pl-4 p-2 bg-gray-400">
        <label for="area" class="text-xl flex-grow font-bold">Expected:</label>
        <textarea
          class="font-bold flex-shrink text-right text-lg rounded p-1 focus:border-2 focus:border-gray-800"
          :value="goal.expected"
          @change="updateGoalProperty($event, 'expected')"
          @keyup.enter="updateGoalProperty($event, 'expected')"
        />
      </div>
      <div class="w-full block flex items-center flex-row pl-4 p-2 bg-gray-300 rounded-b mb-2">
        <label for="actual" class="flex-grow font-bold text-lg">Actual:</label>
        <input
          type="text"
          class="font-bold flex-shrink text-right text-lg py-1 pr-3 rounded focus:border-2 focus:border-gray-800"
          :value="goal.actual"
          @change="updateGoalProperty($event, 'actual')"
          @keyup.enter="updateGoalProperty($event, 'actual')"
        />
      </div>
      <div class="w-full block flex flex-row p-2 bg-gray-800 justify-center">
        <button
          v-on:click="close"
          class="flex font-bold text-lg bg-gray-700 text-white px-3 py-2 rounded-full hover:bg-gray-600 hover:text-black border-white border-2 border-solid active:border-black"
        >Done</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getGoalById"]),
    goal() {
      return this.getGoalById(this.$route.params.id);
    }
  },
  methods: {
    updateGoalProperty(e, key) {
      this.$store.dispatch("updateGoal", {
        goal: this.goal,
        key,
        value: e.target.value
      });
    },
    close() {
      this.$router.push({ name: "goal-board" });
    }
  }
};
</script>

<style>
.goal-view {
  @apply relative flex flex-row bg-gray-800 mx-4 m-32 mx-auto py-4 px-2 text-left rounded shadow;
  max-width: 700px;
}
</style>
*/
